import { useEffect, useState } from 'react';
import { BottomSheet, bottomSheetStyles } from '../BottomSheet/BottomSheet';
import {
  acknowledgeCookieNotice,
  isCookieNoticeAcknowledged,
} from './cookieNoticeState';
import styles from './CookieNotice.module.less';

const SHOW_DELAY_MS = 1000;

/** Уведомление о cookie: один раз на устройстве, на обычных экранах */
export function CookieNotice() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isCookieNoticeAcknowledged()) return;

    const timer = setTimeout(() => setIsOpen(true), SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const acknowledge = () => {
    acknowledgeCookieNotice();
    setIsOpen(false);
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={acknowledge} variant="actions">
      <div className={bottomSheetStyles.group}>
        <div className={styles.body}>
          <h3 className={styles.title}>Мы используем cookie</h3>
          <p className={styles.message}>
            Они нужны, чтобы сервис работал, и помогают понять, как им
            пользуются. Подробнее — в{' '}
            <a
              className={styles.link}
              href={window.__CONFIG__?.legalLinks.privacyPolicy}
              target="_blank"
              rel="noreferrer"
            >
              Политике обработки персональных данных
            </a>
            .
          </p>
        </div>
        <button type="button" className={styles.action} onClick={acknowledge}>
          Понятно
        </button>
      </div>
    </BottomSheet>
  );
}
